import {history, utilHelper} from '../../_helpers';

export const mainService = {
    getModules,
    getMenuSideBar,
    blankOnClickModules,
    getAllPermission,
    getAllMyToDoTask,
    getVersion
};

async function getVersion() {
    return await utilHelper.doRequest('', 'GET');
}

async function getModules() {
    return await utilHelper.doRequest('api/main/getModules', 'GET');
}

async function getAllMyToDoTask() {
    return await utilHelper.doRequest('api/toDoTask/getAllMyToDoTask', 'GET');
}

async function getPermission(module) {
    return await utilHelper.doRequest('api/employee/getPermissionByModule', 'POST', module);
}

function getMenuSideBar(module) {
    return utilHelper.doRequest('api/moduleMenu/search', 'POST', module);
}

async function blankOnClickModules(extraData) {
    this.getMenuSideBar({ module : {id : extraData.module.id} })
        .then(
            menus => {
                if (menus !== '' && menus != null) {
                    const {from} = {from: {pathname: `/main${menus[0].url}`}};
                    localStorage.setItem('menus', JSON.stringify(menus));
                    localStorage.setItem('udns', JSON.stringify(extraData.udns));
                    localStorage.setItem('module', JSON.stringify(extraData.module));
                    localStorage.setItem('selectedUdn', JSON.stringify(extraData.selected));
                    history.push(from);
                }
            },
            error => {
                console.log(error);
            }
        );

    getPermission({id: extraData.module.id})
        .then(permission => {
                if (permission !== '' && permission != null) {
                    localStorage.setItem('permission', JSON.stringify(permission));
                }
            },
            error => {
                console.log(error);
            }
        );
}

function getAllPermission(extraData) {
    getPermission({id: extraData.module.id})
        .then(permission => {
                if (permission !== '' && permission != null) {
                    localStorage.setItem('permission', JSON.stringify(permission));
                }
            },
            error => {
                console.log(error);
            }
        );
}